export default "__VITE_ASSET__933742d3__"